module.exports = __webpack_public_path__ + "f307895862d9e95216bf6fe8cef5321a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/intellektuell.svg
// module id = 4
// module chunks = 0